import { Alert, Button } from "react-bootstrap";
import { Modal, MuniSpinner2 } from "../../../components";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import useActas from "../../../api/actas";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const ModalAprobadaImprimir = ({ modals, handlerModal, setRefetch }) => {

    //?ESTADOS GLOBALES
    const { loads } = useGeneralAppStore();
    const { acta } = useActaDetalleStore();

    //TODO API
    const { marcarActaComoAprobadoParaImprimir } = useActas();

    return (
        <>
            <Modal
                show={modals.includes('aprobada_imprimir')}
                size={"md"}
                onHide={() => handlerModal({ modal: false, modalName: "aprobada_imprimir" })}
                title={() => `Aprobar acta ${acta?.dependencia} - ${acta?.numero_infraccion}`}
            >
                <section className="position-relative">
                    {
                        loads.includes('aprobada_imprimir') &&
                        <div className="w-100 d-flex justify-content-center align-items-center position-absolute top-0 l-0"
                            style={{ background: "rgba(255,255,255,0.8)", zIndex: 999 }}
                        >
                            <MuniSpinner2 />
                        </div>

                    }
                    <Alert>
                        Una vez aprobada el acta, se generara un archivo de acta PDF, revisar que este en orden
                    </Alert>
                    <hr />
                    <div className="d-flex justify-content-end">
                        <Button
                            size="md"
                            variant="success"
                            className="d-flex gap-2 align-items-center"
                            onClick={() => marcarActaComoAprobadoParaImprimir({ id_acta: acta?.id, is_edit: false }, setRefetch)}

                            disabled={loads.includes('aprobada_imprimir')}
                        >
                            <CheckCircleIcon />
                            {loads.includes('aprobada_imprimir')
                                ? "Guardando..."
                                : "Aprobar acta"}
                        </Button>
                    </div>
                </section>
            </Modal >
        </>
    );
}
export default ModalAprobadaImprimir;